import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ba42028"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "Unfolding3DRenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请根据题目按顺序选择答案（允许重复），您可能需要注意答案顺序", -1));
const _hoisted_5 = {
  key: 0,
  class: "ft20 mt16",
  style: {
    "min-height": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_OrderedAnswerButtonGroup = _resolveComponent("OrderedAnswerButtonGroup");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.idx + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questionImages, qimg => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: qimg,
        src: qimg,
        style: {
          "max-width": "70%"
        }
      }, null, 8, ["src"]);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter flex flex-col mt32"
  }, {
    default: _withCtx(() => [_hoisted_4, !$props.reviewMode ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($data.answer), 1)) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.optionImages, qimg => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: qimg,
        src: qimg,
        style: {
          "max-width": "70%"
        }
      }, null, 8, ["src"]);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_OrderedAnswerButtonGroup, {
      onChoose: $options.onChoosed,
      single: false,
      review: $props.review,
      reviewMode: $props.reviewMode,
      options: $options.maxLetterToOptions($props.data.rightAnswer)
    }, null, 8, ["onChoose", "review", "reviewMode", "options"])]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}